import columns from './utils/columns'
import PATHS from '@/router/paths'

const state = {
  columns,
  confirmCancelHome: null,
  deleteIndexHome: null,
  deleteLabelHome: null,
  denyDeleteHome: false,
  formHome: { action: 'update', entry: null, scope: 'list' },
  isModalVisibleHome: false,
  isValidHomeForm: false,
  promptDeleteHome: null,

  metricTypeMap: {
    discrepancy: [
      {
        text: 'line items',
        value: 'totalCount',
      },
    ],
    'network-health': [
      {
        text: 'results',
        value: 'totalCount',
      },
    ],
    'adx-health': [
      {
        text: 'results',
        value: 'totalCount',
      },
    ],
    'adx-and-open-bidding': [
      {
        text: 'results',
        value: 'totalCount',
      },
    ],
    organization: [
      {
        text: 'hours',
        value: 'totalHours',
      },
      {
        text: 'results',
        value: 'totalCount',
      },
    ],
    [PATHS.INTERNAL.TIME_ROLLUP]: [
      {
        text: 'hours',
        value: 'totalHours',
      },
      {
        text: 'time entries',
        value: 'totalCount',
      },
    ],
    pacing: [
      {
        text: 'line items',
        value: 'totalCount',
      },
    ],
    person: [
      {
        text: 'hours',
        value: 'totalHours',
      },
      {
        text: 'results',
        value: 'totalCount',
      },
    ],
    project: [
      {
        text: 'hours',
        value: 'totalHours',
      },
      {
        text: 'results',
        value: 'totalCount',
      },
    ],
  },
  metricGroupByMap: {
    discrepancy: [
      {
        text: 'orders',
        value: 'orderCount',
      },
    ],
    'network-health': [
      {
        text: 'results',
        value: 'totalCount',
      },
    ],
    'adx-health': [
      {
        text: 'results',
        value: 'totalCount',
      },
    ],
    'adx-and-open-bidding': [
      {
        text: 'results',
        value: 'totalCount',
      },
    ],
    organization: [
      {
        text: 'results',
        value: 'totalCount',
      },
      {
        text: 'organizations',
        value: 'billingCodes',
      },
    ],
    [PATHS.INTERNAL.TIME_ROLLUP]: [
      {
        text: 'time entries',
        value: 'totalCount',
      },
      {
        text: 'organizations',
        value: 'billingCodes',
      },
      {
        text: 'persons',
        value: 'persons',
      },
    ],
    pacing: [
      {
        text: 'orders',
        value: 'orderCount',
      },
    ],
    person: [
      {
        text: 'results',
        value: 'totalCount',
      },
      {
        text: 'organizations',
        value: 'billingCodes',
      },
    ],
    project: [
      {
        text: 'results',
        value: 'totalCount',
      },
      {
        text: 'organizations',
        value: 'billingCodes',
      },
    ],
  },
}

export default state
